import React, { useRef } from "react";
import ReactDOM from 'react-dom/client';
import { useSelector, useDispatch } from "react-redux";
import TextareaAutosize from 'react-textarea-autosize';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';

const Answer = () => {
  const { t, i18n } = useTranslation();
  const placeholder = t('Enter your message...');
  const dispatch = useDispatch();
  const messages = useSelector(state => state.app.messages);
  const uuid = useSelector(state => state.uuid.uuid);
  const cHash = useSelector(state => state.app.cHash);
  const isUploading = useSelector(state => state.app.isUploading);
  const isTypingRef = useRef(null);
  const typingTimeoutRef = useRef(null);
  const isClient = useSelector(state => state.app.isClient);
  const clientEmail = useSelector(state => state.app.clientEmail);
  const textarea = useSelector(state => state.app.textarea);
  const disableReply = useSelector(state => state.app.disableReply);

  let messageTextarea = useRef(null);

  const typingTimeoutHandle = () => {
    if (isTypingRef.current == false) {
      return;
    }

    isTypingRef.current = false;
    console.log('stop typing');
    dispatch({ type: 'SEND_CLIENT_END_TYPING', channel: uuid, uuid: uuid});
  }

  const onKeyPress = (e) => {

    if (disableReply) {
      return;
    }

    if (e.which != 13) {
          
      if (isTypingRef.current === null || isTypingRef.current == false) {
        console.log('start typing');
        dispatch({ type: 'SEND_CLIENT_START_TYPING', channel: uuid, uuid: uuid});
      }

      isTypingRef.current = true;
      clearTimeout(typingTimeoutRef.current);
      typingTimeoutRef.current = setTimeout(typingTimeoutHandle, 500);
      return;
    }

    if (e.which == 13 && e.target.value) {

      e.preventDefault();

      if (!trimMessage(e.target.value)) {
        return;
      }
      
      if (!isClient && !clientEmail) {
        dispatch({ type: 'SET_MESSAGE_TO_SEND', message: trimMessage(e.target.value) });
        dispatch({ type: 'TEXTAREA_HEIGHT', height: textarea.defaultHeight, rows: 1 });
        e.target.value = '';
        return;
      }

      const lastMessage = [...messages].pop();
      const date = (lastMessage) ? lastMessage.date : null;
      dispatch({ type: 'SEND_MESSAGE', message: trimMessage(e.target.value), channel: uuid, lastDate: date, files: [] });
      dispatch({ type: 'TEXTAREA_HEIGHT', height: textarea.defaultHeight, rows: 1 });

      e.target.value = '';
    }
  }

  const onClick = (e) => {
    e.preventDefault();

    if (!trimMessage(messageTextarea.value)) {
      return;
    }

    if (!isClient && !clientEmail) {
      dispatch({ type: 'SET_MESSAGE_TO_SEND', message: trimMessage(messageTextarea.value) });
      dispatch({ type: 'TEXTAREA_HEIGHT', height: textarea.defaultHeight, rows: 1 });
      messageTextarea.value = '';
      return;
    }

    const lastMessage = [...messages].pop();
    const date = (lastMessage) ? lastMessage.date : null;
    dispatch({ type: 'SEND_MESSAGE', message: trimMessage(messageTextarea.value), channel: uuid, lastDate: date, files: [] });
    dispatch({ type: 'TEXTAREA_HEIGHT', height: textarea.defaultHeight, rows: 1 });
    messageTextarea.value = '';
  }

  const trimMessage = (msg) => {
    return msg.replace(/^\s+|\s+$/g, "");
  };

  const onChange = ({target}) => {
    if (isUploading) {
      return;
    }

    if (disableReply) {
      return;
    }

    let data = new FormData();

    if (!target.files[0]) {
      return
    }

    [...target.files].map(file => {

      const hash = uuidv4();

      dispatch({ type: 'START_UPLOAD', hash: hash, name: file.name });
      data.append('file', file);

      $.ajax({
        url: '/widget/'+cHash+'/upload?uuid='+uuid,
        data,
        cache: false,
        contentType: false,
        processData: false,
        method: 'POST',
        success: data => {
          target.value = ''
          if (data.status == 'ok') {
            dispatch({ type: 'END_UPLOAD', hash: hash, data: data.fileData });
          } else {
            dispatch({ type: 'END_UPLOAD_ERROR', hash: hash });
          }
        },
        error: e => {
          dispatch({ type: 'END_UPLOAD_ERROR', hash: hash });
          target.value = '';
          console.warn(e)
        }
      })

    });
  }

  let divAnswerHeight = 65 + textarea.diffHeight;
  let divSenderMaxHeight = 69 + textarea.diffHeight;

  return (
    <div className="kil-chat-widget-answer" style={{height: divAnswerHeight+"px"}}>
      <div className="kil-chat-widget-answer-sender" style={{maxHeight: divSenderMaxHeight+"px"}}>
        <div className={"kil-chat-widget-answer-upload upload-file" + ((disableReply) ? ' disabled' : '')}>
          {!isUploading &&
            <i className="fal fa-paperclip fa-rotate-45"><input disabled={disableReply} type="file" onChange={onChange}></input></i>
          }
          {isUploading &&
           <i className="fal fa-spinner fa-spin"></i> 
          }
        </div>

        <div className="kil-chat-widget-answer-new-message">
          <TextareaAutosize 
            ref={(node) => { messageTextarea = node; }}
            maxRows={10}
            autoFocus
            onKeyPress={onKeyPress}
            placeholder={placeholder}
            disabled={disableReply}

            onHeightChange={(height, object) => {
              let rows = (height == textarea.defaultHeight) ? 0 : (height - textarea.defaultHeight) / object.rowHeight; 
              dispatch({ type: 'TEXTAREA_HEIGHT', height: height, rows: rows + 1 });
            }}

          />          
        </div>
        <button disabled={disableReply} onClick={onClick} className="kil-chat-widget-answer-send">
          <i className="kil-chat-widget-answer-send-icon fal fa-level-down fa-rotate-90"></i>
        </button>
      </div>
    </div>
  );
}

export default Answer;